import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthSignal } from '@xanadu/signal';

@Injectable({ providedIn: 'root' })
export class LoginGuard  {
    constructor(
        private router: Router,
        private authSignal: AuthSignal
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const identity = this.authSignal.identity();
        if (identity) {
            // check if user is already logged in. if so go to home page instead.
            this.router.navigate(['/']);
            return false;
        }

        return true;
    }
}
